export function keywordString(keywords = []) {
  return keywords.filter(Boolean).join(', ');
}

export const CITY_SEO_BY_LANG = {
  NOR: {
    oslo: {
      title: 'Finn grav i Oslo – oversikt over gravlunder | Nettgrav',
      description:
        'Her kan du finne grav i Oslo og se hvilke gravlunder personen er gravlagt på. Søk etter navn direkte, eller velg gravlund for å finne riktig gravsted.',
      keywords: keywordString([
        'finn grav Oslo',
        'finn en grav Oslo',
        'gravlund Oslo',
        'Oslo gravlunder',
        'Oslo gravplasser',
        'søk grav Oslo',
        'finne grav i Oslo',
      ]),
      heading: 'Finn grav i Oslo',
      body: [
        'Her kan du finne grav i Oslo og se hvilke gravlunder personen er gravlagt på. Søk etter navn direkte, eller velg gravlund for å finne riktig gravsted.',
        'Oslo har flere gravlunder. Velg gravlund nedenfor for å søke etter grav eller finne gravsted.',
      ],
    },
    bergen: {
      title: 'Finn grav i Bergen – Gravplasser i Bergen | Nettgrav',
      description:
        'Finn grav i Bergen med Nettgrav. Bergen-siden dekker byens gravplasser, inkludert Møllendal og Fana kirkegård, slik at du enkelt kan søke etter graver i Norges nest største by.',
      keywords: keywordString([
        'finn grav Bergen',
        'finn en grav Bergen',
        'gravplass Bergen',
        'Bergen gravplass',
        'Bergen gravlund',
        'søk grav i Bergen',
        'finne grav i Bergen',
      ]),
      heading: 'Finn grav i Bergen',
      body: [
        'Finn grav i Bergen ved å søke i alle byens gravplasser. Nettgrav samler gravlister for Bergen, fra historiske kirkegårder i sentrum til gravlunder som Fana og Åsane.',
        'Søk på navn for å finne gravsted og gravplass. Med Nettgrav blir det enklere å finne grav i Bergen uten å lete i flere tjenester.',
      ],
    },
    trondheim: {
      title: 'Finn grav i Trondheim – Gravlunder i Trondheim | Nettgrav',
      description:
        'Finn grav i Trondheim med Nettgrav. Siden dekker Trondheim sine gravlunder, inkludert Tilfredshet og Lademoen kirkegård, slik at du raskt kan finne gravsted.',
      keywords: keywordString([
        'finn grav Trondheim',
        'finn en grav Trondheim',
        'gravlund Trondheim',
        'Trondheim gravlund',
        'Trondheim kirkegård',
        'gravsteder i Trondheim',
        'søk grav Trondheim',
      ]),
      heading: 'Finn grav i Trondheim',
      body: [
        'Finn grav i Trondheim med Nettgravs samlede søk for byens gravlunder og kirkegårder. Her får du oversikt over store gravplasser som Tilfredshet og mindre kirkegårder i nærområdene.',
        'Søk på navn for å finne gravsted og plassering. Nettgrav gjør det enklere å finne grav i Trondheim fra ett sted.',
      ],
    },
    stavanger: {
      title: 'Finn grav i Stavanger – Gravlunder i Stavanger | Nettgrav',
      description:
        'Finn grav i Stavanger med Nettgrav. Stavanger-siden dekker byens gravlunder, inkludert Eiganes Gravlund og Lagård gravlund, slik at du enkelt kan søke etter graver.',
      keywords: keywordString([
        'finn grav Stavanger',
        'finn en grav Stavanger',
        'gravlund Stavanger',
        'Stavanger gravlund',
        'Eiganes gravlund',
        'Stavanger gravminner',
        'søk grav Stavanger',
      ]),
      heading: 'Finn grav i Stavanger',
      body: [
        'Finn grav i Stavanger ved å søke i alle byens gravlunder. Nettgrav samler gravlister fra Eiganes Gravlund og andre kirkegårder i kommunen.',
        'Søk på navn for å finne gravsted og datoer. Nettgrav gjør det enklere å finne grav i Stavanger på ett sted.',
      ],
    },
    kristiansand: {
      title: 'Finn grav i Kristiansand – Gravplasser i Kristiansand | Nettgrav',
      description:
        'Finn grav i Kristiansand med Nettgrav. Kristiansand-siden dekker lokale gravplasser som Oddernes og Lund, slik at du raskt kan finne grav og minneplass.',
      keywords: keywordString([
        'finn grav Kristiansand',
        'finn en grav Kristiansand',
        'gravplass Kristiansand',
        'Kristiansand gravplass',
        'Kristiansand kirkegård',
        'søk grav Kristiansand',
        'finne grav i Kristiansand',
      ]),
      heading: 'Finn grav i Kristiansand',
      body: [
        'Finn grav i Kristiansand ved å søke i kommunens gravplasser. Nettgrav samler gravlister fra Oddernes kirkegård og andre lokale gravplasser.',
        'Søk på navn for å finne gravsted og gravplass. Nettgrav gjør det enklere å finne grav i Kristiansand uten å lete flere steder.',
      ],
    },
    drammen: {
      title: 'Finn grav i Drammen – Kirkegårder i Drammen | Nettgrav',
      description:
        'Finn grav i Drammen med Nettgrav. Drammen-siden dekker lokale kirkegårder som Bragernes og Strømsø, slik at du enkelt kan søke etter graver.',
      keywords: keywordString([
        'finn grav Drammen',
        'finn en grav Drammen',
        'gravlund Drammen',
        'Drammen gravlund',
        'Drammen kirkegård',
        'søk grav Drammen',
        'finne grav i Drammen',
      ]),
      heading: 'Finn grav i Drammen',
      body: [
        'Finn grav i Drammen ved å søke i byens kirkegårder og gravlunder. Nettgrav samler gravlister fra Bragernes, Strømsø, Tangen og flere.',
        'Søk på navn for å finne gravsted og plassering. Nettgrav gjør det enkelt å finne grav i Drammen fra ett søk.',
      ],
    },
  },
  ENG: {
    oslo: {
      title: 'Find a grave in Oslo – cemetery overview | Nettgrav',
      description:
        'Find graves in Oslo and see which cemetery a person is buried in. Search by name, or choose a cemetery to narrow your search.',
      keywords: keywordString([
        'gravlund Oslo',
        'find a grave Oslo',
        'Oslo gravlund',
        'Oslo gravplasser',
        'finne grav i Oslo',
        'Oslo cemetery search',
        'burial records Oslo',
      ]),
      heading: 'Find a grave in Oslo',
      body: [
        'Find graves in Oslo and see which cemetery a person is buried in. Search by name, or choose a cemetery to narrow your search.',
        'Oslo has several cemeteries. Choose a cemetery below to continue your search and find the right grave site.',
      ],
    },
    bergen: {
      title: 'Find a Grave in Bergen – Gravplasser i Bergen | Nettgrav',
      description:
        'Locate graves in Bergen with Nettgrav’s search. Our Bergen page covers all local cemeteries (gravplasser i Bergen), including major sites like Møllendal and Fana kirkegård, so you can easily find burial records in Norway’s second-largest city.',
      keywords: keywordString([
        'gravplass Bergen',
        'find a grave Bergen',
        'Bergen gravplass',
        'Bergen gravlund',
        'søke grav i Bergen',
        'Bergen cemetery records',
        'find grave in Bergen Norway',
      ]),
      heading: 'Find a grave in Bergen',
      body: [
        'Find a grave in Bergen by searching through every cemetery in the municipality. Nettgrav’s Bergen listings encompass all gravplasser (burial grounds) in Bergen – from historic churchyards in the city center to suburban gravlunds like Fana and Åsane.',
        'Use this page to search for a deceased by name or browse a specific cemetery’s records. With support for Bergen’s major cemeteries, parish churchyards and memorial parks, Nettgrav helps you finn en grav in Bergen quickly and reliably.',
      ],
    },
    trondheim: {
      title: 'Find a Grave in Trondheim – Gravlunder i Trondheim | Nettgrav',
      description:
        'Search for graves in Trondheim on Nettgrav. This page covers all Trondheim gravlunder (cemeteries), including well-known sites like Tilfredshet and Lademoen kirkegård, enabling quick access to burial records in Trondheim.',
      keywords: keywordString([
        'gravlund Trondheim',
        'find a grave Trondheim',
        'Trondheim gravlund',
        'Trondheim kirkegård',
        'gravsteder i Trondheim',
        'Trondheim burial search',
        'finn grav Trondheim',
      ]),
      heading: 'Find a grave in Trondheim',
      body: [
        'Find a grave in Trondheim by using Nettgrav’s unified search for the city’s cemeteries. Our Trondheim section includes all gravlunder og kirkegårder in the area – from large municipal cemeteries like Tilfredshet to smaller parish churchyards.',
        'You can search by name to find burial information and grave locations for individuals interred in Trondheim. Major cemeteries such as Lademoen kirkegård, Moholt kirkegård and Leinstrand kirkegård are indexed, ensuring comprehensive coverage.',
      ],
    },
    stavanger: {
      title: 'Find a Grave in Stavanger – Gravlunder i Stavanger | Nettgrav',
      description:
        'Find burial sites in Stavanger with Nettgrav. Our Stavanger page lists all gravlunder i Stavanger, including Eiganes Gravlund and Lagård gravlund, so you can search for graves and view memorials in this city.',
      keywords: keywordString([
        'gravlund Stavanger',
        'find a grave Stavanger',
        'Stavanger gravlund',
        'Eiganes gravlund Stavanger',
        'Stavanger gravminner',
        'grave search Stavanger',
        'finn en grav Stavanger',
      ]),
      heading: 'Find a grave in Stavanger',
      body: [
        'Find a grave in Stavanger via Nettgrav’s grave search for the Stavanger area. This page provides access to burial records from every cemetery in Stavanger, such as Eiganes Gravlund (the city’s main cemetery) and historic churchyards like Hetland kirkegård.',
        'Whether you are looking up a family member’s grave or exploring local history, Nettgrav lets you search across all of Stavanger’s cemeteries in one place. Simply enter a name to finn en grav and retrieve grave locations, dates and cemetery information for the deceased.',
      ],
    },
    kristiansand: {
      title: 'Find a Grave in Kristiansand – Gravplasser i Kristiansand | Nettgrav',
      description:
        'Explore Kristiansand burial records on Nettgrav. The Kristiansand page includes all local gravplasser (Oddernes, Lund, etc.), helping you find graves and memorials in Kristiansand quickly.',
      keywords: keywordString([
        'gravplass Kristiansand',
        'find a grave Kristiansand',
        'Kristiansand gravplass',
        'Kristiansand kirkegård',
        'Oddernes kirkegård Kristiansand',
        'grave lookup Kristiansand',
        'finne grav i Kristiansand',
      ]),
      heading: 'Find a grave in Kristiansand',
      body: [
        'Find a grave in Kristiansand by searching through all of the city’s cemeteries on Nettgrav. Our Kristiansand section compiles data from every gravplass in the municipality – from Oddernes kirkegård, the city’s large historic cemetery, to smaller parish graveyards in outlying districts.',
        'Enter a person’s name to retrieve their burial record, including grave location and cemetery name. Nettgrav ensures that anyone can finn en grav i Kristiansand without needing to search multiple church registries.',
      ],
    },
    drammen: {
      title: 'Find a Grave in Drammen – Kirkegårder i Drammen | Nettgrav',
      description:
        'Access Drammen grave records via Nettgrav. The Drammen page covers all local cemeteries (Bragernes, Strømsø, Tangen, etc.), allowing you to find graves in Drammen with ease.',
      keywords: keywordString([
        'gravlund Drammen',
        'find a grave Drammen',
        'Drammen kirkegård',
        'Drammen gravlund',
        'Bragernes gravminner',
        'søk grav Drammen',
        'find grave in Drammen Norway',
      ]),
      heading: 'Find a grave in Drammen',
      body: [
        'Find a grave in Drammen by using Nettgrav’s search across all kirkegårder og gravlunder in Drammen. This page consolidates burial registers for sites like Bragernes kirkegård as well as Strømsø, Åssiden gravlund and Tangen.',
        'Simply search for the deceased’s name to find grave location details and dates of burial. Nettgrav’s Drammen listings ensure you can finn en grav in any cemetery within Drammen municipality from one search.',
      ],
    },
    malmo: {
    title: 'Find a Grave in Malmö – Malmös kyrkogårdar | Nettgrav',
    description:
      'Search Malmö cemetery records on Nettgrav. Our Malmö page includes all 17 local cemeteries (Östra kyrkogården, Gamla kyrkogården, S:t Pauli, etc.) so you can hitta en grav i Malmö or find a grave in English, all in one place.',
    keywords: keywordString([
      'find a grave Malmö',
      'hitta grav Malmö',
      'Malmö gravar sök',
      'Östra kyrkogården Malmö',
      'hitta gravplats Malmö',
      'Malmö cemetery search',
      'find grave in Malmö Sweden',
    ]),
    heading: 'Hitta grav i Malmö',
    body: [
      'Find a grave in Malmö by searching across the city’s 17 cemeteries. Nettgrav’s Malmö section combines the burial registers for sites like Östra kyrkogården (Malmö Eastern Cemetery) – the city’s largest cemetery – as well as historic Gamla kyrkogården in the city center and all parish graveyards in Malmö’s districts.',
      'Users can input a name to retrieve grave details, or use Swedish keywords (e.g. “hitta grav Malmö”) to narrow the search. Nettgrav bridges the data from Malmö pastorat into one searchable interface, making it simple to hitta en grav in Malmö municipality.',
    ],
  },
  uppsala: {
    title: 'Find a Grave in Uppsala – Hitta grav i Uppsala | Nettgrav',
    description:
      'Find graves in Uppsala with Nettgrav’s search. The Uppsala page covers all local cemeteries (Gamla kyrkogården, Berthåga, etc.), allowing you to hitta gravplats or find a grave in Uppsala easily.',
    keywords: keywordString([
      'find a grave Uppsala',
      'hitta grav Uppsala',
      'Uppsala gravar',
      'Uppsala kyrkogård sök',
      'hitta graven Uppsala',
      'Uppsala burial records',
      'find grave Uppsala Sweden',
    ]),
    heading: 'Hitta grav i Uppsala',
    body: [
      'Find a grave in Uppsala by utilizing Nettgrav’s comprehensive database of Uppsala’s cemeteries. This page lets you search burial records from Uppsala’s kyrkogårdar – including the historic Gamla kyrkogården in central Uppsala and newer cemeteries like Berthåga begravningsplats.',
      'Nettgrav’s integration means that whether you use English (find a grave) or Swedish (hitta en grav Uppsala) search terms, you’ll get results from all participating Uppsala cemeteries in one place.',
    ],
  },
  linkoping: {
    title: 'Find a Grave in Linköping – Hitta grav i Linköping | Nettgrav',
    description:
      'Search for burial records in Linköping on Nettgrav. The Linköping page includes all local cemeteries (Gamla kyrkogården, Ryd, etc.), enabling you to hitta en grav i Linköping or find a grave internationally.',
    keywords: keywordString([
      'find a grave Linköping',
      'hitta grav Linköping',
      'Linköping gravplats sök',
      'Linköpings kyrkogårdar',
      'hitta gravplats Linköping',
      'Linkoping cemetery search',
      'find grave Linkoping Sweden',
    ]),
    heading: 'Hitta grav i Linköping',
    body: [
      'Find a grave in Linköping by searching Nettgrav’s index of Linköping cemeteries. We combine records from all major Linköpings begravningsplatser, including the old city cemetery and newer memorial parks.',
      'Enter the person’s name to see where they are buried, with details like cemetery name and grave plot. Both Swedish and English queries are supported so that you can hitta gravplatsen i Linköping using familiar terms.',
    ],
  },
  helsinki: {
    title: 'Find a Grave in Helsinki – Helsingin hautausmaat | Nettgrav',
    description:
      'Search Helsinki graves with Nettgrav. Our Helsinki page covers all 6 city cemeteries (Malmi, Hietaniemi, Honkanummi, etc.) allowing you to find burial records in Finland’s capital (hae hauta Helsingin hautausmailta).',
    keywords: keywordString([
      'hautausmaa Helsinki',
      'find a grave Helsinki',
      'Helsingin hautausmaa haku',
      'Hietaniemen hautausmaa haku',
      'Malmin hautausmaa löytää hauta',
      'Helsinki cemetery search',
      'find grave Helsinki Finland',
    ]),
    heading: 'Hae hautaa Helsingissä',
    body: [
      'Find a grave in Helsinki by using Nettgrav’s integrated search of Helsinki’s cemeteries. This page provides access to records from all six Helsinki cemeteries: Hietaniemen hautausmaa, Malmin hautausmaa, Honkanummen hautausmaa, Maunulan uurnalehto, Kulosaaren hautausmaa and Östersundomin hautausmaa.',
      'The interface supports both English and Finnish searches so that you can löytää haudan Helsingissä regardless of language. Nettgrav brings Helsingin seurakuntayhtymä data into one place for convenient access.',
    ],
  },
  espoo: {
    title: 'Find a Grave in Espoo – Espoon hautausmaat | Nettgrav',
    description:
      'Find graves in Espoo on Nettgrav. The Espoo page covers all local cemeteries (Espoon tuomiokirkko graveyard, Espoonlahti, etc.), helping you search burial records in Espoo, Finland (hae hauta Espoossa).',
    keywords: keywordString([
      'hautausmaa Espoo',
      'find a grave Espoo',
      'Espoon hautausmaa haku',
      'Espoo hautapaikka etsi',
      'find grave Espoo Finland',
      'Espoo cemetery records',
      'hautahaku Espoo',
    ]),
    heading: 'Etsi hauta Espoosta',
    body: [
      'Find a grave in Espoo by searching across Espoo’s cemeteries with Nettgrav. All major Espoon hautausmaat – such as the Espoo Cathedral cemetery and regional graveyards in Espoonlahti, Leppävaara and other parts of the city – are included.',
      'Enter the person’s name to get grave location details and dates. Nettgrav mirrors data from Espoon seurakuntayhtymä so you can löytää vainajan hautapaikka Espoossa using either Finnish or English search terms.',
    ],
  },
  vantaa: {
    title: 'Find a Grave in Vantaa – Vantaan hautausmaat | Nettgrav',
    description:
      'Search burial records in Vantaa on Nettgrav. The Vantaa page includes all local cemeteries (Honkanummi, Helsingin Pitäjän churchyard, etc.), so you can löytää hauta Vantaalta or find a grave in Vantaa easily.',
    keywords: keywordString([
      'hautausmaa Vantaa',
      'find a grave Vantaa',
      'Vantaan hautausmaa haku',
      'Vantaa hautapaikat',
      'Honkanummi hautausmaa haku',
      'find grave Vantaa Finland',
      'Vantaa cemetery search',
    ]),
    heading: 'Hae hauta Vantaalta',
    body: [
      'Find a grave in Vantaa by using Nettgrav’s Vantaa section. This page consolidates information from Vantaan hautausmaat, including Honkanummen hautausmaa and the historic Helsingin pitäjän kirkon hautausmaa.',
      'Search results include grave locations and burial details so you can quickly löytää haudat Vantaalla without visiting multiple services.',
    ],
  },
  tampere: {
    title: 'Find a Grave in Tampere – Tampereen hautausmaat | Nettgrav',
    description:
      'Find graves in Tampere with Nettgrav’s search. The Tampere page spans all main cemeteries (Kalevankangas, Lamminpää, etc.), enabling you to etsiä hauta Tampereelta or find a grave in Tampere, Finland.',
    keywords: keywordString([
      'hautausmaa Tampere',
      'find a grave Tampere',
      'Tampere hautausmaa haku',
      'Kalevankankaan hautausmaa etsi',
      'Tampere grave search',
      'find grave Tampere Finland',
      'Tampereen hautapaikka',
    ]),
    heading: 'Etsi hauta Tampereella',
    body: [
      'Find a grave in Tampere by searching the combined database of Tampere’s cemeteries on Nettgrav. This page covers Tampereen hautausmaat, including Kalevankankaan hautausmaa and Lamminpään hautausmaa.',
      'Simply input a name to retrieve grave records such as location and dates. Nettgrav’s Tampere service supports Finnish and English queries so that Tampereen hautapaikat are easy to explore.',
    ],
  },
  turku: {
    title: 'Find a Grave in Turku – Turun hautausmaat | Nettgrav',
    description:
      'Search Turku graves on Nettgrav. Our Turku page covers all local cemeteries (Turku main cemetery, Maaria, etc.), so you can löytää hauta Turusta or find a grave in Turku quickly.',
    keywords: keywordString([
      'hautausmaa Turku',
      'find a grave Turku',
      'Turun hautausmaa haku',
      'Åbo gravplats sök',
      'Turku cemetery search',
      'löytää haudan Turku',
      'find grave Turku Finland',
    ]),
    heading: 'Hae hautaa Turusta',
    body: [
      'Find a grave in Turku by utilizing Nettgrav’s integration of Turun hautausmaat. This page allows you to search burial records from the city’s graveyards, including Turun hautausmaa, Maarian hautausmaa and other parish cemeteries.',
      'Enter the deceased’s name to find their grave’s location and relevant dates. Nettgrav supports both Finnish and English search terms so you can löytää haudat Turussa from one place.',
    ],
  },
}};

const FIND_GRAVE_SLUG_SET = new Set([
  'finn-en-grav',
  'find-a-grave',
  'find-en-grav',
  'hitta-en-grav',
  'etsi-hauta',
]);
const FIND_GRAVE_LANG_BY_SLUG = {
  'finn-en-grav': 'NOR',
  'find-a-grave': 'ENG',
  'find-en-grav': 'DAN',
  'hitta-en-grav': 'SWE',
  'etsi-hauta': 'FIN',
};

function normaliseSlug(value = '') {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function getCitySeoBySlug(slug, lang = 'ENG') {
  const normalised = normaliseSlug(slug);
  const primary = CITY_SEO_BY_LANG[lang] || CITY_SEO_BY_LANG.ENG || CITY_SEO_BY_LANG.NOR;
  return (
    primary?.[normalised] ||
    CITY_SEO_BY_LANG.ENG?.[normalised] ||
    CITY_SEO_BY_LANG.NOR?.[normalised] ||
    null
  );
}

export function getCitySeoByPath(pathname = '') {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length < 2) return null;
  if (!FIND_GRAVE_SLUG_SET.has(segments[0])) return null;
  const lang = FIND_GRAVE_LANG_BY_SLUG[segments[0]] || 'NOR';
  const slug = segments[1];
  return getCitySeoBySlug(slug, lang);
}
